import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import IconMaximize from '@/design-system/assets/icons/IconMaximize2.vue'
import IconMinimize from '@/design-system/assets/icons/IconMinimize2.vue'
type Props = {
  fullscreen?: boolean
  size?: string
}

type Emits = {
  (e: 'toggleFullscreen'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonFullscreen',
  props: {
    fullscreen: { type: Boolean },
    size: {}
  },
  emits: ["toggleFullscreen"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit

function handleSpaceKey(event: Event) {
  event.preventDefault() // Prevent space bar scrolling
  emits('toggleFullscreen')
}

return (_ctx: any,_cache: any) => {
  return (!_ctx.fullscreen)
    ? (_openBlock(), _createBlock(IconMaximize, {
        key: 0,
        class: "button-fullscreen",
        role: "button",
        tabindex: "0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFullscreen'))),
        onKeydown: [
          _cache[1] || (_cache[1] = _withKeys(($event: any) => (emits('toggleFullscreen')), ["enter"])),
          _cache[2] || (_cache[2] = _withKeys((event) => handleSpaceKey(event), ["space"]))
        ]
      }))
    : (_openBlock(), _createBlock(IconMinimize, {
        key: 1,
        class: _normalizeClass(["button-fullscreen", { medium: _ctx.size === 'medium' }]),
        role: "button",
        tabindex: "0",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('toggleFullscreen'))),
        onKeydown: [
          _cache[4] || (_cache[4] = _withKeys(($event: any) => (emits('toggleFullscreen')), ["enter"])),
          _cache[5] || (_cache[5] = _withKeys((event) => handleSpaceKey(event), ["space"]))
        ]
      }, null, 8, ["class"]))
}
}

})